
/**
 * Edit Controller
 */
(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');

    app.controller('AgencyEditController', [
        '$scope',
        '$window',
        'agencyApi',
        'optionsApi',
        function($scope, $window, agencyApi, optionsApi) {
            $scope.countries = [];

            $scope.agency = {
                name: "",
                short_name: "",
                has_adgap: false,
            };
            $scope.agencyList = null;

            $scope.log = {
                count: 0,
                data: [],
            };

            // load agency from server
            if ($window.agencyId) {
                agencyApi.read($window.agencyId).then(
                    function(data) {
                        $scope.agency = data.agency;
                        $scope.log = data.log;
                    },
                    function() {
                        console.error('could not load agency');
                    }
                );
            }


            // try saving and process server side validation errors
            $scope.submitForm = function() {
                agencyApi.save($scope.agency).then(
                    function() {
                        $window.location.href = '/#!/demandmgr/agency';
                    },
                    function(data) {
                        if (data.message){
                            alert(data.message);
                        }
                        for (var field in data.invalid) {
                            if ($scope.agencyForm[field]) {
                                $scope.agencyForm[field].$setValidity(data.invalid[field], false);
                            }
                        }
                    }
                );
            };

            $scope.isNameUnique = function(field) {
                if ($scope.agencyForm && $scope.agencyForm.hasOwnProperty(field)) {
                    return !$scope.agencyForm[field].$error.unique;
                }

                return true;
            };
        },
    ]);
})(window.angular);
